import React, { useEffect, useState } from "react";
import { FaUser, FaIdBadge, FaBuilding, FaUserTag, FaCircle } from "react-icons/fa";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [userRecord, setUserRecord] = useState(null);
  const [error, setError] = useState("");

  const localUserId = localStorage.getItem("user_id") || "";
  const localName = localStorage.getItem("name") || "Default Name";
  const localUsername = localStorage.getItem("username") || "Default User";
  const localUserType = localStorage.getItem("user_type") || "Default Role";
  const localRoleName = localStorage.getItem("role_name") || "";
  const localDepartment = localStorage.getItem("department") || "";

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${Apiurl}/user`);
        const allUsers = response.data || [];
        const match = allUsers.find((u) => u.user_id === localUserId);
        setUserRecord(match || null);
      } catch (err) {
        console.error("Error fetching profile:", err);
        setError("Could not load latest profile details from the server.");
      } finally {
        setLoading(false);
      }
    };

    if (localUserId) {
      fetchProfile();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const status = userRecord?.status || "";
  const roleName =
    userRecord?.roles_details?.[0]?.role_name || localRoleName || "-";
  const department =
    userRecord?.staff_details?.department ||
    userRecord?.doctor_details?.department ||
    localDepartment ||
    "-";

  return (
    <div className="container-fluid py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8">
          <div className="card border-0">
            <div className="card-body p-4 p-md-5">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: 72,
                    height: 72,
                    background:
                      "linear-gradient(135deg, var(--brand-700, #01AEBE) 0%, var(--brand-500, #B9D542) 100%)",
                    color: "#fff",
                    fontSize: "1.8rem",
                    fontWeight: 600,
                  }}
                >
                  {localName?.charAt(0)?.toUpperCase() || "U"}
                </div>
                <div>
                  <h3 className="mb-1">{localName}</h3>
                  <span className="text-muted">
                    {localUsername} &middot; {localUserType}
                  </span>
                </div>
              </div>

              {error && (
                <div className="alert alert-warning py-2">{error}</div>
              )}

              {loading ? (
                <div className="text-center text-muted py-4">
                  Loading profile...
                </div>
              ) : (
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="p-3 border rounded d-flex align-items-center">
                      <FaIdBadge className="me-2 text-secondary" />
                      <div>
                        <div className="text-muted small">User ID</div>
                        <div className="fw-semibold">{localUserId || "-"}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 border rounded d-flex align-items-center">
                      <FaUser className="me-2 text-secondary" />
                      <div>
                        <div className="text-muted small">Username</div>
                        <div className="fw-semibold">{localUsername}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 border rounded d-flex align-items-center">
                      <FaUserTag className="me-2 text-secondary" />
                      <div>
                        <div className="text-muted small">Role</div>
                        <div className="fw-semibold">{roleName}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 border rounded d-flex align-items-center">
                      <FaBuilding className="me-2 text-secondary" />
                      <div>
                        <div className="text-muted small">Department</div>
                        <div className="fw-semibold">{department}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 border rounded d-flex align-items-center">
                      <FaCircle
                        className={`me-2 ${
                          status?.toLowerCase() === "active"
                            ? "text-success"
                            : "text-secondary"
                        }`}
                        size={10}
                      />
                      <div>
                        <div className="text-muted small">Status</div>
                        <div className="fw-semibold">{status || "-"}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
